import { useLocalization } from "../../hooks/useLocalization";
import { winrate } from "../../utils/leaderboard/stats";

interface WinratePillsProps {
  wins: number | null;
  losses: number | null;
}

const PILL_BASE =
  "inline-flex items-center justify-center whitespace-nowrap rounded-md px-[0.55rem] py-[0.28rem] text-[0.78rem] font-semibold";

export const WinratePills = ({ wins, losses }: WinratePillsProps) => {
  const { strings } = useLocalization();
  const w = wins ?? 0;
  const l = losses ?? 0;
  const rate = winrate(w, l);
  const winLabel = strings.SCOREBOARD.GRID_TEAM_WINS;
  const lossLabel = strings.SCOREBOARD.GRID_TEAM_LOSSES;

  if (!w && !l) {
    return <span className="text-[#8b8b9a]">—</span>;
  }

  return (
    <div className="opgg-winrate flex flex-wrap items-center gap-[0.45rem]">
      <span className={`${PILL_BASE} bg-[#2a2a36] text-[#e8e8ef]`}>
        {w}
        {winLabel} - {l}
        {lossLabel}
      </span>
      <span className={`${PILL_BASE} min-w-10 bg-[#4a5fc9] text-white`}>{rate}%</span>
    </div>
  );
};
